import { useQuery } from '@tanstack/react-query'
import type { DashboardAggregates, DashboardFilters } from '@myapp/contract'
import { dashboardApi } from '../dashboardApi'
import { dashboardKeys } from '../keys'

export function useDashboardAggregatesQuery(filters: DashboardFilters) {
  return useQuery<DashboardAggregates>({
    queryKey: dashboardKeys.aggregate(filters),
    queryFn: () => dashboardApi.getAggregates(filters).then((r) => r.data),
    // Keep the old figures on screen while a new period loads instead of flashing the skeleton.
    placeholderData: (prev) => prev,
  })
}
